import { AbstractStoreRoot, registerStore, StoreRoot, StoreRootEventDetailMap } from '@genesislcap/foundation-store';
import { CustomEventMap } from '@genesislcap/foundation-events';
import { getApp } from '@genesislcap/foundation-shell/app';
import { observable } from '@genesislcap/web-core';
import {MaturityOrder} from "../components/deals/deal-series/deal-series.types";



export interface PbiStore extends StoreRoot {
  cancelledOrders: MaturityOrder[];
}

export enum PbiStoreEvents {
  CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS'
}

export type PbiStoreEventsMap = StoreRootEventDetailMap & {
  [PbiStoreEvents.CANCEL_ORDER_SUCCESS]: MaturityOrder[];
};

declare global {
  interface HTMLElementEventMap extends CustomEventMap<PbiStoreEventsMap> { }
}

class DefaultPbiStore extends AbstractStoreRoot<PbiStore, PbiStoreEventsMap> implements PbiStore {

  @observable cancelledOrders: MaturityOrder[];

  constructor() {
    super();

    /**
     * Register the store root
     */
    getApp().registerStoreRoot(this);

    this.createListener<MaturityOrder[]>(PbiStoreEvents.CANCEL_ORDER_SUCCESS,
      (cancelledOrders) => {
        this.cancelledOrders = cancelledOrders;
      }
    );
  }
}

export const PbiStore = registerStore(DefaultPbiStore, 'PbiStore');
